import { useTranslation } from 'react-i18next';
import Modal from 'shared/ui/modal';

const SuccessModal = ({ isOpen, onContinue }) => {
  const { t } = useTranslation('common');

  return (
    <Modal
      title={t('password_reset_success')}
      isOpen={isOpen}
      setIsOpen={() => {}}
      footer={false}
      closeModal={false}
    >
      <p className="text-gray-700 text-sm">{t('password_reset_description')}</p>
      <div className="w-full flex justify-center text-center mt-6">
        <button
          type="button"
          onClick={onContinue}
          className="flex w-full bg-blue-500 justify-center rounded-md bg-con-brand px-3 py-2 text-medium font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          {t('continue_to_login')}
        </button>
      </div>
    </Modal>
  );
};

export default SuccessModal;
